import React, { useState, useRef, useEffect, useContext } from "react";
import { useHistory, NavLink } from "react-router-dom";
import { Grid, } from 'semantic-ui-react'
import renderHTML from 'react-render-html';
import "../DidyouknowDitelsScreen/DidyouknowditelsScreen.scss";
import playbutton from "../../assets/home/playbutton.svg";
import white_arrow from "../../assets/home/white_arrow.svg";
import { useTranslation } from "react-i18next";
import { StarButton } from '../../components'
import { useSelector, useDispatch } from "react-redux";
import { getDiduknows } from "../../store/OrderRedux";
import { Config } from "../../common"


const DidyouknowDitelsScreen = () => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token)
  const diduknow = useSelector((state) => state.order.diduknow)

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  let newItem = Config.GetLanguageSameLine(diduknow, i18n.language)

  return (

    <div className="container-fluid bg clearall">
      <div className="celibetry_secs">

      </div>
      <div className="DidyouknowDitels">
        <div>
          {/* <div className="white_arrow" ><img src={white_arrow}  onClick={() => history.push("/")} /></div> */}
          <div className="detail_bg">
            <video
              autoplay="autoplay"
              onClick={() => {
                const video = document.getElementById("videoId");
                if (video.muted) {
                  video.muted = false;
                } else {
                  video.muted = true;
                }
              }}
              muted
              loop
              id="videoId"
              className="white_car"
              width="100%"
              height="500px"
              // ojectFit="cover"
              style={{
                objectFit: "cover",
              }}
            >
              <source
                type="video/mp4"
                src={diduknow.videoURL}
              ></source>
            </video>
          </div>
          {/* <div className="videp_button"><img className="play_btns" src={playbutton} /></div> */}
          <h5>{newItem.heading} </h5>
          {renderHTML(newItem.text || "<p></p>")}
        </div>
        <Grid centered columns={16} >
          <Grid.Row>
            <div className="conditionbt">
              <StarButton background={'mainBg'} title={t("didiyoyknowditels.btn")} onClickAction={() => history.push("/")} />
            </div>
          </Grid.Row>
        </Grid>


      </div>
    </div>
  );
};

export default DidyouknowDitelsScreen